import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@mui/material';
import MealDetailReadOnlyDesktop from './meal_detail_read_only_desktop';
import { useIsMobile } from '../common/layout_hooks';
import MealDetailReadOnlyMobile from './meal_detail_read_only_mobile';
import { useGetGRCRecipesByIDsQuery } from '../../app/smorgAppSyncGraphQLApi';
import { DEFAULT_SPACE_ID } from '../../services/spaces';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { userIsCreator } from '../../services/users';

const GRCRecipeDetailContainer = ({ grcRecipeID, visible, dismiss }) => {
  const isMobile = useIsMobile();
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery(
    undefined,
    {
      skip: !userProfile || isSmorgStudio,
    },
  );

  const isCommunityUser = currentSpaceMembership?.spaceID === DEFAULT_SPACE_ID;

  const { data: grcRecipes } = useGetGRCRecipesByIDsQuery([grcRecipeID]);

  const grcRecipe = (grcRecipes || {})[grcRecipeID];

  if (!visible || !grcRecipe) {
    return null;
  }

  const { derivedNutrition } = grcRecipe;

  console.log(`GRCRecipeDetail grcRecipeID=${grcRecipeID}`);

  const onDialogClose = (ev, reason) => {
    if (reason === 'escapeKeyDown') {
      console.log('Dialog escape key down');
      // Prevent dialog from closing, let the contenteditable handle the esc key
      return null;
    }
    console.log(`Dialog close other reason: ${reason}`);
    dismiss();
    return true;
  };

  const showNutritionMetrics = [
    'calories',
    'fat',
    'carbohydrate',
    'protein',
    'fibre',
  ];

  const pseudoMeal = {
    recipes: [grcRecipe.recipe],
  };

  const alwaysShowNutrition = !isCommunityUser;

  return (
    <Dialog open maxWidth="md" fullWidth onClose={onDialogClose}>
      {isMobile ? (
        <MealDetailReadOnlyMobile
          menu="-"
          meal={pseudoMeal}
          showNutritionMetrics={showNutritionMetrics}
          alwaysShowNutrition={alwaysShowNutrition}
          showMacroRatio
          hidePublisher
          derivedNutrition={derivedNutrition}
          canScaleIngredients={false}
          scaleToServings={grcRecipe.recipe?.servings}
          onIngredientCheckChange={() => {}}
          onDialogClose={onDialogClose}
        />
      ) : (
        <MealDetailReadOnlyDesktop
          menu="-"
          meal={pseudoMeal}
          showNutritionMetrics={showNutritionMetrics}
          alwaysShowNutrition={alwaysShowNutrition}
          showMacroRatio
          hidePublisher
          derivedNutrition={derivedNutrition}
          canScaleIngredients={false}
          scaleToServings={grcRecipe.recipe?.servings}
          onIngredientCheckChange={() => {}}
          onDialogClose={onDialogClose}
        />
      )}
    </Dialog>
  );
};

GRCRecipeDetailContainer.propTypes = {
  grcRecipeID: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  dismiss: PropTypes.func,
};

GRCRecipeDetailContainer.defaultProps = {
  grcRecipeID: null,
  dismiss: () => {},
};

export default GRCRecipeDetailContainer;
